/* eslint-disable global-require, import/no-dynamic-require */

export default {
  login: require(`${process.env.DYCOLOR_REQUIRE}./components/login/Login.scss`),
  header: require(`${process.env.DYCOLOR_REQUIRE}./components/header/Header.scss`),
  'login-email': require(`${process.env.DYCOLOR_REQUIRE}./components/login/email/Email.scss`),
  'form-input': require(`${process.env.DYCOLOR_REQUIRE}./components/form-input/FormInput.scss`),
  'file-upload': require(`${process.env.DYCOLOR_REQUIRE}./components/file-upload/FileUpload.scss`),
  'search-table': require(`${process.env.DYCOLOR_REQUIRE}./components/search-table/SearchTable.scss`),
  daterangepicker: require(`${process.env.DYCOLOR_REQUIRE}./components/daterangepicker/Daterangepicker.scss`),
  'gotu-nav-button': require(`${process.env.DYCOLOR_REQUIRE}./components/gotu-nav-button/GotuNavButton.scss`),
  'search-table-filters': require(`${process.env.DYCOLOR_REQUIRE}./components/search-table/filters/Filters.scss`),
  'creative-refresh': require(`${process.env.DYCOLOR_REQUIRE}./components/creative-refresh/CreativeRefresh.scss`),
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/dycolor.js